"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = DataFilterNote;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function DataFilterNote(_ref) {
  var filters = _ref.filters,
      theme = _ref.theme;
  var index = filters.index,
      population = filters.population,
      shareOfAttribute = filters.shareOfAttribute,
      shareOfAudience = filters.shareOfAudience;

  if (theme.length || index || population || shareOfAttribute || shareOfAudience) {
    return /*#__PURE__*/_react["default"].createElement("div", null, "Modify the filters and/or reduce thresholds, to include more attributes.");
  } else {
    return '';
  }
}